/**
 * author: danielda
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");

    var BillingCRMDetailsModel = {};
    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette, $, _) {

        BillingCRMDetailsModel = BaseModel.extend({
            name: "BillingCRMDetailsModel",
            initialize: function(options) {
                var mode = (options && options.mode) || BillingCRMDetailsModel.MODES.TRIAL;
                this.resource= _.clone(ApiResources.Billing.BillingCRMDetails);
                this.resource.url = this.resource.url.replace("{mode}", mode);
            }
        });
    });

    BillingCRMDetailsModel.MODES = {
        TRIAL: "TRIAL",
        PAYING: "PAYING"
    };


    return BillingCRMDetailsModel;
});

